export enum BitrateType {
    None = 0,
    HD720P = 449,
    SD180P = 457,
    SD100P = 460,
    SD270P = 461,
    SD360P = 472,
}

export class Trailer {
    movieId: number
    title: string
    url: string
    bitrate: BitrateType

    constructor() {

    }

    deserialize(input: any) {
        this.movieId = input.RootId
        this.title = input.Title
        this.url = input.Url
        this.bitrate = input.BitrateId
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/shared/trailer.model.ts